import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import PublicLayout from "sections/PublicLayout";

function SchoolAboutUs() {
  return (
    <PublicLayout
      eyebrow="(Regd.) ISO 9001:2015 certified"
      title="A1 Play School"
      subtitle="Let's fly your child 🏫"
    >
      <Container>
        <Grid container justifyContent="center" sx={{ py: { xs: 3, md: 5 } }}>
          <Grid item xs={12} md={9} lg={8}>
            <MKBox mb={4}>
              <MKTypography variant="h4" mb={1.5}>
                About our play school
              </MKTypography>
              <MKTypography variant="body2" color="text">
                We follow the early years foundation stage curriculum to ensure a holistic growth in
                children through experimental methods. We introduce activities that urge a child to
                engage, involve, enquire, apply, and learn by doing it themselves. Vaccinated staff,
                CCTV, Sanitizer, and much more. We give top priority to our Children&apos;s safety
                and hygiene. We have activities like role plays, painting, Dress-ups, poem
                recitation, sports competitions, Birthday Celebrations, Festival celebrations, and
                much more to combine learning with play. Ramleela: Role Play done by students to
                make them aware of our great epic Ramayana. Krishna Janmashtami: Students played
                various activities of Lord Krishna and celebrated Lord Krishna&apos;s birthday.
                Birthday Celebration: Birthday of each student is celebrated in a unique way as it
                is the most important event for a child. Fun in Picnic: We take our students to safe
                and most enjoyable places for Picnic each year. Playing Activity: We let our little
                stars play on various types of swings and slides under the supervision of a teacher
                inside the school as well as outside in the park. A1 Play School is totally
                committed to the holistic development of each student to make them confident and
                smarter. We also provide the best daycare facilities for kids in our area at
                affordable prices.
              </MKTypography>
            </MKBox>

            <MKBox>
              <MKTypography variant="h5" mb={1.5}>
                Result
              </MKTypography>
              <MKTypography variant="body2" color="text">
                Our fundamental laxal aim is to achieve the zenith of paramount knowledge and spread
                it on a global scale. Today we must cooperate massively to enhance and correlate
                enjoying the amenities of modern educational apparatus. Indeed, we intend to
                emphasize moral laxity among students in the contemporary era. We endeavour our best
                to uplift educational standards by and bound. It is our pledgeful duty to encourage
                the level of high standards of education dynamically present in today&apos;s
                scientific scenario.
              </MKTypography>
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </PublicLayout>
  );
}

export default SchoolAboutUs;
